/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2020-12-08 11:32:59
 * @LastEditors: yy
 * @LastEditTime: 2020-12-09 10:51:18
 */

import moment from 'moment'

const copy = (source, target) => {
  const result = {}
  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      const element = target[key];
      result[key] = element
    }
  }
  return result
}

const obj2arr = (source) => {
  let arr = []
  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      const element = source[key];
      arr[element] = key
    }
  }
  return arr
}

export const formatWeek = (data) => {
  const CUT_LINE = '_CUT_LINE_'
  const DAY  = 7
  const group = {}
  data.list.forEach(item => {
    const dayGroup = ~~(parseInt(moment(item.value[1]).format('DDD')) / DAY)
    const key = `${dayGroup}${CUT_LINE}${item.name}`
    
    if (!group[key]) {
      group[key] = []
    }
    group[key].push(item)
  })

  // 数据
  const result = []
  for (const key in group) {
    if (group.hasOwnProperty(key)) {
      const ele = group[key]
      let item = null 
      ele.forEach((element, i) => {
        if (i === 0) {
          item = element
        } else {
          item.value[2] = moment.max(moment(item.value[2]), moment(element.value[2])).format('YYYY-MM-DD') 
          item.value[3] += element.value[3]
        }
      });
      result.push(item)
    }
  }

  // 取出开始和结束日期
  const date = [data.date.shift()]
  const pop = data.date.pop()
  data.date.forEach(item => {
    const d = parseInt(moment(item).format('DDD')) / DAY
    if (d === ~~d) {
      date.push(item)
    }
  })

  // 最后一天
  date.push(pop)

  data.date = date
  data.list = result
}


/**
 * 修改数据按月分组
 * @param {*} data 
 */
export const formatMonth = (data) => {
   // -------------------------------数据按月算- begin-------------------------------
   let days = new Set();
   data.date.forEach(item => {
     days.add(item.replace(/-\d{2}$/, ''))
   })

   let map = {}

   data.list.forEach(item => {
     const key = item.value[1].replace(/-\d{2}$/, '') + ' | ' + item.name
     if (key in map) {
       map[key].value[3] = map[key].value[3] + item.value[3]
     } else {
       const m = moment(item.value[1])
       map[key] = {
         name: item.name,
         value: [
           item.value[0],
           m.format('YYYY-MM'),
           m.add(1, 'M').format('YYYY-MM'),
           item.value[3]
         ]
       }
     }
   })
   let result = []
   for (const key in map) {
     if (map.hasOwnProperty(key)) {
       const element = map[key];
       result.push(element)
     }
   }
   data.date = Array.from(days)
   data.list = result
}

/**
 * 只对filterList 里面的数据展示
 * @param {*} data 
 */
export const formatFilterForList = (data) => {
  const filterList = [
    // "旷视科技",
    "旷视唐文斌获评2019“中国科学年度新闻人物”",
    "旷视出席世界互联网大会",
    "推出“AI加速计划”",
    "发布FaceStyle，入局AI美妆",
    "旷视科技与易华录合资成立新公司",
    "旷视科技IPO申请获港交所批准",
    "申请“狗脸识别”专利",
    "旷视科技入局安防",
    "回应招股书失效",
    "推出AI测温神器，智能抗疫",
    "旷视科技将筹备科创板上市",
    "开源Brain++的深度学习框架",
    "发力智慧物流业务",
    "蚂蚁金服回应为旷视提供人脸数据"
  ]
  data.list = data.list.filter(item => {
    return filterList.includes(item.name)
  })
}

/**
 * 重置顺序
 * @param {*} data 
 */
export const formatSort = (data) => {
  const filterMap = {
    "旷视科技": 3,
    "旷视唐文斌获评2019“中国科学年度新闻人物”": 1,
    "旷视出席世界互联网大会": 2,
    "推出“AI加速计划”": 0,
    "发布FaceStyle，入局AI美妆": 4,
    // "旷视科技与易华录合资成立新公司",
    // "旷视科技IPO申请获港交所批准",
    // "申请“狗脸识别”专利",
    // "旷视科技入局安防",
    // "回应招股书失效",
    // "推出AI测温神器，智能抗疫",
    // "旷视科技将筹备科创板上市",
    "开源Brain++的深度学习框架": 5,
    "发力智慧物流业务": 6,
    "蚂蚁金服回应为旷视提供人脸数据": 7
  }

 
  data.list = data.list.filter(item => typeof filterMap[item.name] === 'number').map(({name, value}) => {
    const i = filterMap[name]
    value[0] = i
    return {
      name: name,
      value: value
    }
  })
  data.total_nums = copy(filterMap, data.total_nums)
  data.yAxis = obj2arr(filterMap)
}



// WEBPACK FOOTER //
// src/routes/customChart/HotTopic/format.js